export default __webpack_public_path__ + "static/jetson_vehicle_front_mobile-248ec35577084d84ab8e78f798272457.png";